<template>
  <div class="form-group filter-item">
    <label class="control-label">{{ filter.label }}</label>
    <v-select
      v-model="filter.value"
      :multiple="filter.multiple"
      :options="filter.options"
      :close-on-select="false"
      placeholder="Please select."
      label="text"

      @input="selectFilter"
      @option:deselected="$emit('option:deselected', true)"
    />
  </div>
</template>
<script>
import VSelect from 'vue-select'

export default {
  components: {VSelect},
  props: ['filter'],
  methods: {
    selectFilter(val) {
      if (this.filter.multiple && !val.length) {
        this.$set(this.filter, 'value', null);
      } else {
        this.$set(this.filter, 'value', val);
      }

      this.$emit('value-updated');
    },
  }
}
</script>